<template>
    <v-container class="pa-0">
        <v-card class="pa-2 pa-sm-3" style="position: relative">
            <div>
                <span class="oh-label"><TranslatableStringComponent :tstring="{string: 'shippingAccount'}" /> #:</span>
                <span :class="`oh-data strong`">
                    {{ shippingAccountNumber || 'c3controls' }}</span
                >
            </div>
            <div class="mb-4">
                <span class="oh-label"><TranslatableStringComponent :tstring="{string: 'shipVia'}" />:</span>
                <span :class="`oh-data strong`">
                    {{
                        item.OrderShippingMethod &&
                        item.OrderShippingMethod.name
                            ? item.OrderShippingMethod.name
                            : '---'
                    }}</span
                >
            </div>
            <div>
                <v-timeline dense clipped class="pa-0">
                    <v-timeline-item
                        class=""
                        :color="getStatus.slug === 'shipped' ? 'green' : 'grey'"
                        small
                    >
                        <v-row justify="space-between">
                            <v-col cols="8" class="pl-0 py-2 pr-2 pa-sm-4">
                                <strong>
                                    <TranslatableStringComponent :tstring="{string: 'shipped'}" />
                                    <TranslatableStringComponent :tstring="{string: 'invoiced'}" />
                                </strong>
                                <div
                                    v-if="getStatus.slug === 'shipped'"
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    <p class="mb-0">
                                        <em><TranslatableStringComponent :tstring="{string: 'orderHistoryStatusMessageShipped'}" /></em>
                                    </p>
                                    <div class="mb-0">
                                        <TranslatableStringComponent :tstring="{string: 'track'}" /> #:
                                        <span v-if="trackingIdList.length > 0">
                                            <span
                                                v-for="trackingId in trackingIdList"
                                                :key="
                                                    trackingId.shippingTrackingNumber
                                                "
                                            >
                                                <a
                                                    :href="`${calcTrackingURL(
                                                        trackingId.shippingTrackingNumber
                                                    )}`"
                                                    target="_blank"
                                                >
                                                    {{
                                                        calcTrackingString(
                                                            trackingId.shippingTrackingNumber
                                                        )
                                                    }}
                                                    <fa
                                                        :icon="[
                                                            'fal',
                                                            'external-link',
                                                        ]"
                                                        class="fa-sm ml-2"
                                                /></a>
                                            </span>
                                        </span>
                                        <span v-else><TranslatableStringComponent :tstring="{string: 'unavailable'}" /></span>
                                    </div>
                                    <p class="mb-0">
                                        Invoice #
                                        {{
                                            salesInvoice && salesInvoice.docNo
                                                ? salesInvoice.docNo
                                                : '--'
                                        }}
                                    </p>
                                    <p class="mb-0">
                                        PO #
                                        {{
                                            salesInvoice &&
                                            salesInvoice.shippingPoNumber
                                                ? salesInvoice.shippingPoNumber
                                                : '--'
                                        }}
                                    </p>
                                </div>
                                <div v-else></div>
                            </v-col>
                            <v-col
                                class="text-right pl-0 py-2 pr-2 pa-sm-4"
                                cols="4"
                            >
                                <div
                                    v-if="getStatus.slug === 'shipped'"
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    {{
                                        convertToReadabledate(
                                            item.transactionDate
                                        )
                                    }}
                                </div>
                                <div v-else>...</div>
                            </v-col>
                        </v-row>
                    </v-timeline-item>
                    <v-timeline-item
                        class=""
                        :color="
                            ['packed', 'shipped'].includes(getStatus.slug)
                                ? 'green'
                                : 'grey'
                        "
                        small
                    >
                        <v-row justify="space-between">
                            <v-col cols="8" class="pl-0 py-2 pr-2 pa-sm-4">
                                <strong><TranslatableStringComponent :tstring="{string: 'packed'}" /></strong>
                                <div
                                    v-if="
                                        ['packed', 'shipped'].includes(
                                            getStatus.slug
                                        )
                                    "
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    <p class="mb-0">
                                        <em><TranslatableStringComponent :tstring="{string: 'packageReadyToBeShipped'}" /></em>
                                    </p>
                                    <p class="mb-0">
                                        Shipper #
                                        {{
                                            shipper && shipper.docNo
                                                ? shipper.docNo
                                                : '--'
                                        }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col
                                class="text-right pl-0 py-2 pr-2 pa-sm-4"
                                cols="4"
                            >
                                <div
                                    v-if="getStatus.slug === 'packed'"
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    {{
                                        convertToReadabledate(
                                            shipper.transactionDate
                                        )
                                    }}
                                </div>
                                <div v-else>...</div>
                            </v-col>
                        </v-row>
                    </v-timeline-item>
                    <v-timeline-item
                        class=""
                        :color="
                            ['processing', 'packed', 'shipped'].includes(
                                getStatus.slug
                            )
                                ? 'green'
                                : 'grey'
                        "
                        small
                    >
                        <v-row justify="space-between">
                            <v-col cols="8" class="pl-0 py-2 pr-2 pa-sm-4">
                                <strong><TranslatableStringComponent :tstring="{string: 'processing'}" /></strong>
                                <div
                                    v-if="
                                        [
                                            'processing',
                                            'packed',
                                            'shipped',
                                        ].includes(getStatus.slug)
                                    "
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    <p class="mb-0">
                                        <em><TranslatableStringComponent :tstring="{string: 'orderBeingProcessed'}" /></em>
                                    </p>
                                    <p class="mb-0">
                                        <em><TranslatableStringComponent :tstring="{string: 'expectedShipDate'}" />:</em>
                                        {{
                                            salesOrder &&
                                            salesOrder.shippingDate
                                                ? convertToReadabledate(
                                                      salesOrder.shippingDate
                                                  )
                                                : '--'
                                        }}
                                    </p>
                                    <p class="mb-0">
                                        Sales Order #
                                        {{
                                            salesOrder && salesOrder.docNo
                                                ? salesOrder.docNo
                                                : '--'
                                        }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col
                                class="text-right pl-0 py-2 pr-2 pa-sm-4"
                                cols="4"
                            >
                                <div
                                    v-if="
                                        salesOrder && salesOrder.transactionDate
                                    "
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    {{
                                        convertToReadabledate(
                                            salesOrder.transactionDate
                                        )
                                    }}
                                </div>
                                <div v-else>...</div>
                            </v-col>
                        </v-row>
                    </v-timeline-item>
                    <v-timeline-item color="green" small>
                        <v-row justify="space-between">
                            <v-col cols="8" class="pl-0 py-2 pr-2 pa-sm-4">
                                <strong><TranslatableStringComponent :tstring="{string: 'orderPlaced'}" /></strong>
                                <div
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    <p class="mb-0">
                                        <em><TranslatableStringComponent :tstring="{string: 'yourOrderHasBeenPlaced'}" /></em>
                                    </p>
                                    <p class="mb-0">
                                        {{
                                            webOrder
                                                ? 'Web Order #'
                                                : 'Sales Order #'
                                        }}
                                        {{
                                            webOrder && webOrder.docNo
                                                ? webOrder.docNo
                                                : salesOrder.docNo
                                        }}
                                    </p>
                                    <p class="mb-0">
                                        PO #
                                        {{
                                            webOrder &&
                                            webOrder.shippingPoNumber
                                                ? webOrder.shippingPoNumber
                                                : salesOrder &&
                                                  salesOrder.shippingPoNumber
                                                ? salesOrder.shippingPoNumber
                                                : '--'
                                        }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col
                                class="text-right pl-0 py-2 pr-2 pa-sm-4"
                                cols="4"
                            >
                                <div
                                    :style="
                                        $vuetify.breakpoint.xsOnly &&
                                        'font-size:12px'
                                    "
                                >
                                    {{
                                        webOrder
                                            ? convertToReadabledate(
                                                  webOrder.transactionDate
                                              )
                                            : convertToReadabledate(
                                                  salesOrder.transactionDate
                                              )
                                    }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-timeline-item>
                </v-timeline>
            </div>
            <v-btn
                icon
                style="position: absolute; top: 8px; right: 8px"
                @click="closeDialog()"
            >
                <fa
                    :icon="['fal', 'times-circle']"
                    class="fa-lg"
                    style="color: #999ba3; font-size: 28px"
                />
            </v-btn>
        </v-card>
    </v-container>
</template>
<script>
import handleAuth from '~/mixins/handleAuth'
import handleSnackbar from '~/mixins/handleSnackbar'
import calcTrackingURL from '~/util/calcTrackingURL'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'OrderTrackingCard',
    components: {
        TranslatableStringComponent,
    },
    mixins: [handleSnackbar, handleAuth],
    props: {
        order: {
            type: Object,
            default: null,
        },
        salesOrder: {
            type: Object,
            default: null,
        },
        webOrder: {
            type: Object,
            default: null,
        },
        shipper: {
            type: Object,
            default: null,
        },
        salesInvoice: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            trackingIdList: [],
        }
    },
    computed: {
        item() {
            return this.order
        },
        getStatus() {
            if (this.item.workFlowStatus === 'Customer contact required') {
                return {
                    label: this.localize('contactSupport'),
                    slug: 'contact',
                    desc: this.localize('orderHistoryStatusMessageContact'),
                }
            }
            if (this.item.docType === 'Sales Invoice') {
                return {
                    label: this.localize('shipped'),
                    slug: 'shipped',
                    desc: this.localize('orderHistoryStatusMessageShipped'),
                }
            } else if (this.item.docType === 'Shipper') {
                return {
                    label: this.localize('packed'),
                    slug: 'packed',
                    desc: this.localize('orderHistoryStatusMessagePacked'),
                }
            } else if (this.item.docType === 'Sales Order') {
                return {
                    label: this.localize('processing'),
                    slug: 'processing',
                    desc: this.localize('orderHistoryStatusMessageProcessing'),
                }
            } else if (this.item.docType === 'Web Order') {
                return {
                    label: this.localize('pending'),
                    slug: 'pending',
                    desc: this.localize('orderHistoryStatusMessagePending'),
                }
            } else {
                return { label: 'N/A', slug: '' }
            }
        },
        shippingAccountNumber() {
            return this.item.shippingAccountNumber
        },
    },

    async mounted() {
        if (
            (this.item.docType === 'Shipper' ||
                this.item.docType === 'Sales Invoice') &&
            this.salesOrder
        )
            await this.fetchTrackingNumber()
    },

    methods: {
        async fetchTrackingNumber() {
            const res = await this.$axios.post(
                'erp-orderShipment?method=read',
                {
                    docNo: this.salesOrder?.docNo,
                }
            )
            this.trackingIdList = res.data?.orderShipments
            //removing duplicate tracking numbers
            this.trackingIdList = this.trackingIdList.sort((a, b) => {
                return a.id > b.id ? -1 : 1
            })
            this.trackingIdList = this.trackingIdList.filter(
                (obj, index, self) =>
                    index ===
                    self.findIndex(
                        (el) =>
                            el['shippingTrackingNumber'] ===
                            obj['shippingTrackingNumber']
                    )
            )
            console.log(this.trackingIdList)
        },

        calcTrackingURL(trackingId) {
            return calcTrackingURL(trackingId)
        },
        calcTrackingString(tracking) {
            return tracking || 'N/A'
        },
        calcStrong(str) {
            return str === 'N/A' ? '' : ' strong'
        },
        closeDialog() {
            this.$emit('closeDialog', false)
        },
        convertToReadabledate(isoDate) {
            return isoDate
                ? new Intl.DateTimeFormat('en-US').format(new Date(isoDate))
                : ''
        },
    },
}
</script>
<style lang="scss" scoped>
.oh-data {
    &.oh-status {
        &.shipped {
            color: $success;
        }
        &.processing {
            color: $warning;
        }
        &.pending,
        &.contact {
            color: $error;
        }
    }
    &.strong {
        font-weight: bold;
    }
}
</style>
